module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/smartmap-f045cd4bcd744742a4a011ef25d5179d.jpeg";